import ControlSelect from "@/components/Form/SelectBox/ControlSelect";
import { useTranslation } from "react-i18next";
import { useContext, useEffect } from "react";
import { futureReferencingOptions } from "./Constant";
import { DistributionStepContext } from "../../summery/DistributionContext";

//@ts-ignore
function FutureReferencingLogic({
  control,
  setValue,
  getValues,
  selectedId,
  disabled,
  handleChange,
}: any) {
  const { t } = useTranslation();
  let filteredOpt: any = [];
  const distributionStepContextData: any = useContext<any>(
    DistributionStepContext
  );
  if (!distributionStepContextData.showRelativeYearOption) {
    futureReferencingOptions.forEach((opt: any) => {
      if (opt.value !== "1") {
        filteredOpt.push(opt);
      }
    });
  } else {
    filteredOpt = [...futureReferencingOptions];
  }
  useEffect(() => {
    if (selectedId && selectedId !== "") {
      setValue(
        "futureReferencingLogic",
        !(
          !distributionStepContextData.showRelativeYearOption &&
          selectedId?.toString() === "1"
        )
          ? selectedId !== "null"
            ? selectedId?.toString()
            : ""
          : ""
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, selectedId]);

  let defaultOption = {
    value: "",
    label: t("global.globalPlaceholder.pleaseSelect"),
  };
  const optionList = [defaultOption, ...filteredOpt];
  return (
    <ControlSelect
      name={"futureReferencingLogic"}
      control={control}
      showLabel={true}
      label={t(
        `pages.distributions.distributionStepsTab.stepFormLabels.futureReferencingLogic`
      )}
      options={optionList}
      required={true}
      setValue={setValue}
      getValues={getValues}
      disabled={disabled}
      handleChange={handleChange}
    />
  );
}

export default FutureReferencingLogic;
